//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

// custom pages
import Context from "context/context";
import useDebounce from "helpers/useDebounce";
import OverWriteApi from "apis/overwrite/overwrite";
import { toastCss, successCss } from "assets/styleJS/global";
import Create from "./Create";
import { Styles } from "./styles";
import Loader from "components/Loader/Loader";
import Table from "components/Table/Table";
import searchIcon from "assets/img/Search_Icon.png";

// material-ui
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

// material-ui icons
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import access from "config/access";
import { blockInvalidChar } from "helpers/blockInvalidChar";
import * as moment from "moment";
import { CSVLink } from 'react-csv';
import { exportHeaders } from "./export";


// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
        marginTop: 0,
      },
    },
  },
})(TextField);

const GlobalCss = withStyles({
  "@global": {
    ".MuiOutlinedInput-root": {
      borderRadius: 20,
      marginTop: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child':
    {
      paddingLeft: 20,
    },
  },
})(() => null);

export default function OverWrite() {
  const { state, dispatch } = useContext(Context);
  const { search, update,pointExport } = OverWriteApi();

  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState({});
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchResponse, setSearchResponse] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [response, setResponse] = useState(false);
  const [exportData, setExportData] = useState([]);


  const handleExport = async () => {
    // let values = {};
    // let values = {};
        let values;

    if (searchValue) {
      values = { searchValue };
    }
    // setLoading(true)
    values = {
        searchValue,

        
    };

    dispatch({ type: "SET_LOADING", payload: true });
    let res = await pointExport(values);
    console.log(res,"ragav")
    if (res && res.data) {
        // setIsLoading(false);
        setExportData(res.data);
        dispatch({ type: "SET_LOADING", payload: false });
       
        if (res.data.length === 0) {
          toast.success(t("No Data Found"), { toastId: "no-report-date" });
          return false;
        }
       
        return true;
      }
    }


  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Points Adjustments"],
    });
  }, []);

  const classes = Styles();
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const tableHeadings = [
    "Transaction Id",
    "Order Date",
    "Billto",
    "Loyalty Id",
    "Type",
    "Transaction Type",
    "Transaction Status",
    "View More",
  ];
  const handlePagination = (value) => {
    setOffset(value);
  };

  // handling search api call
  useEffect(() => {
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    }
  }, [searchBounceValues, offset]);

  // search api func
  const handleSearch = async () => {
    setEditData([]);
    try {
      let values;
      values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      setLoading(true);
      let res = await search(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setResponse(true);
        setLoading(false);
        setSearchResponse(true);
      }
      setLoading(false);
    } catch (e) {
      console.log("errors");
    }
  };

  // update api func
  const handleUpdate = async () => {
    try {
      let values;
      values = {
        orderLineNumber: editData.order_line_number,
        extendedSalesAmount: editData.extended_sales_amount,
        orderId: editData.order_id,
      };
      let res = await update(values);
      if (res && res.success) {
        toast.success(i18n.language == 'fr' ? res.french_message : res.message, successCss);
      } else {
        toast.error(i18n.language == 'fr' ? res.french_message : res.message, toastCss);
      }
    } catch (e) {
      console.log("errors");
    }
  };

  return (
    <React.Fragment>
      {activeTab == 0 ? <><GlobalCss />
      <Grid container spacing={0}>
        <div className={classes.headingText2}>{state?.userInfo?.loyalty_organization_name == 'Henry Schein Canada' ? t('Please type the Loyalty ID or Billto ID') : t('Please type the Loyalty ID')}</div>
        <Grid xs={12} item style={{ display: "flex" }}>
          <Grid xs={12} lg={6}>
            <CssTextField
              id="enterPassword"
              placeholder={state?.userInfo?.loyalty_organization_name == 'Henry Schein Canada' ? t('Search for Loyalty Id or Billto ID') : t('Search for Loyalty Id')}
              type={"number"}
              onWheel={(e) => e.target.blur()}
              variant="outlined"
              autoComplete="off"
              onKeyDown={blockInvalidChar}
              className={classes.searchInput}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {!loading && searchValue.length > 0 ? (
                      <CloseOutlinedIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setResponse(false)
                          setSearchValue("");
                          setOffset(1);
                        }}
                      />
                    ) : loading && searchValue.length > 0 ? <div class="snippet" style={{ marginLeft: 23 }}>
                      <div class="stage">
                        <div class="dot-typing-p"></div>
                      </div>
                    </div> :
                      (<img
                        src={searchIcon}
                        alt=""
                        width="20px"
                        className={classes.searchInputIcon}
                      />
                      )}
                  </InputAdornment>
                ),
              }}
              value={searchValue}
              onChange={(e) => {
                if (e.target.value == '') {
                  setResponse(false)
                }
                setSearchValue(e.target.value);
                setOffset(1);
              }}
              onClick={() => {
                setOffset(offset);
              }}
            />
          </Grid>

          <Grid item xs={12} lg={6} className={classes.btnGrid}>
            <Button
              className={"dash-1-filter-btn"}
              // disabled={!access['editAccess'][state.userInfo?.role]['overwrite']}
              onClick={() => {
                if (state?.userInfo?.editAction) {
                  setEditData({});
                  setData([]);
                  setActiveTab(1);
                  return;
                }
                else {
                  toast.error(state.userInfo?.editAccess)
                  return;
                }
              }}
            >
              {t('Add New')}
            </Button>
          </Grid>
          <CSVLink
            id="csv"
            data={exportData
               }
             headers={exportHeaders}
         filename={
              `Point-Adjustment` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
                <button
            // disabled={isLoading}
            className={classes.exportBtn1}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>
        </Grid>
      </Grid>
      <Loader Loading={state.loading} top={"15%"}>
        <Grid className={classes.tableGrid}>
          <Grid xs={12} sm={12} lg={12}>
            {!loading && response && (
              <Table
                headings={tableHeadings.map((i) => (
                  <div key={t(i)} style={{ width: "100%" }}>{t(i)}</div>
                ))}
                data={
                  data.map((d, i) => [
                    d?.transaction_id,
                    d?.order_date,
                    d?.customer_billto_account_number,
                    d?.loyalty_id,
                    t(d?.type),
                    d?.transaction_type || "-",
                    d?.transaction_status,
                    [
                      <RemoveRedEyeIcon
                        className={classes.RemoveRedEyeIcon}
                        onClick={() => {
                          history.push("/dashboard/view-overwrite", {
                            transactionId: d?.transaction_id,
                            offset: offset,
                            searchValue: searchValue,
                          });
                        }}
                      />,
                    ],
                  ])
                }
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            )}
          </Grid>
        </Grid>
      </Loader></> : <Create setActiveTab={setActiveTab} />}
    </React.Fragment>
  )
}
